<template>
  <div>
    <a-tabs>
      <a-tab-pane key="1" tab="时间设置">
        <TimeSetting />
      </a-tab-pane>
      <a-tab-pane key="2" tab="学生报名">
        <StudentApplication />
      </a-tab-pane>
      <a-tab-pane key="3" tab="资格审核">
        <QualificationReview />
      </a-tab-pane>
      <a-tab-pane key="4" tab="报名信息维护">
        <ApplicationMaintenance />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import TimeSetting from '../graduation/TimeSetting.vue'
import StudentApplication from '../graduation/StudentApplication.vue'
import QualificationReview from '../graduation/QualificationReview.vue'
import ApplicationMaintenance from '../graduation/ApplicationMaintenance.vue'

export default {
  components: {
    TimeSetting,
    StudentApplication,
    QualificationReview,
    ApplicationMaintenance
  }
}
</script>